export class UserModel{
    constructor(
        public mail: String,
        public telefono: String,
        public celular: String,
        public razon: String
    ){}
  
    static clone(obj: UserModel){
        return new UserModel(obj.mail,obj.telefono,obj.celular,obj.razon);
    }
  
    static fromJson(obj: any){
        return new UserModel(obj.mail,obj.telefono,obj.celular,obj.razon);
    }
  
    static new(){
        return new UserModel('','','','');
    }
  }